import { boot } from 'quasar/wrappers'
import AxiosErrorHandler from 'components/AxiosErrorHandler.js'
import axios from 'axios'

const ApiAxiosInstance = axios.create();

export default ({ app, router, store }) => {
  ApiAxiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.security.token

  app.config.globalProperties.ApiAxios = ApiAxiosInstance;
  store.ApiAxios = ApiAxiosInstance;
}

export { ApiAxiosInstance }
